import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../api/Service';
import { getErrorMessage } from '../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import history from '../../router/browserrouter';
import {store} from "../store";


export default function* watcherAddCompanyCreditSaga() {
    yield takeEvery("COMPANY_CREDIT", workerSaga);
}

function* workerSaga(action) {
    try {
      var payload={};
        yield put({ type: "DISPLAY_LOADER" });
        // let payload = {}
        yield request("post", action.payload, "add-company-credit").then(response => {
        });
        alert("Credit Added Successfully !!!!")
        yield request(
            "get",
            action.payload,
            "get-credit-details?companyId=" + store.getState().persistReducer.companyId
        ).then((response) => {
            payload = response;
        });
        yield put({ type: "PERSIST_CREDIT",payload:payload });
        var roles = store.getState().persistReducer.roles;
        yield put({ type: "DISPLAY_LOADER" });
        switch (roles[0]) {
            case "App Owner":
                return history.push("/home");
            case "Sales Representative":
                return history.push("/main/sales/dashboard");
            case "Inventory Manager":
                return history.push("/main/inventory");
            case "Inventory Manager":
                return history.push("/main/admin/dashboard");
            default:
                return history.push("/user/login");
        }
    } catch (e) {
        console.log("add-company-saga", e)
        console.log("add-company-saga", e.response)
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
